import { takeEvery, put, fork, call, all, select } from 'redux-saga/effects';
import * as provinceSlice from './provinceSlice';
import * as uiSlice from '../../../UI/redux/uiSlice';
import { authReducerActions, authSagaActions } from '../../../Auth';
import { getAllProvincesApi } from './provinceAPI'; 


export function* onLoadProvincesStartAsync(){

    try{
        
        yield put(provinceSlice.actions.startCall({ callType: provinceSlice.callTypes.list }));

        const getAuth = (state) => state.auth;
        const auth = yield select(getAuth);

        if(!auth.userName || !auth.sessionKey){
            yield put(authSagaActions.logout());
            return
        }

        let reqBody = {
            username: auth.userName,
            key: auth.sessionKey
        };

        const response = yield call(getAllProvincesApi, reqBody);        

        if(response.status === 200){
            let entities = response.data;
            yield put(provinceSlice.actions.provincesFetched({ entities }));
        }
    }
    catch(error){

        console.log(error);

        if(error.response.status === 403){

            yield put(authReducerActions.loggedOut());
            
        } else {
            let errorMsg = "There was an error retrieving province information.";
            
            if(error.response.status === 404){

                let status = error.response.status;
                let msg = "Page Not Found.";

                yield put(uiSlice.actions.error({ status, msg }));
            } else if(error.response.status === 500){

                let status = error.response.status;
                let msg = "Internal Error";

                yield put(uiSlice.actions.error({ status, msg }));

            }

            // yield put(uiSlice.actions.showNotification({
            //     status:"error",
            //     title:"Error",
            //     message: errorMsg
            // }));

            yield put(provinceSlice.actions.catchError({
                callType: provinceSlice.callTypes.list,
                error: errorMsg
            }));
        }
    }

};

export const actionTypes = {

    FetchProvinces: "[FetchProvinces] Fetch Provinces API Action"
};

export const actions = {

    fetchProvinces: () => ({ type: actionTypes.FetchProvinces, payload: undefined })
  
};

export function* fetchProvinces(){

    yield takeEvery(actionTypes.FetchProvinces, onLoadProvincesStartAsync);    
};


const fSagas = [
    fork(fetchProvinces)
];

export function* saga(){
    yield all ([...fSagas]);
};
